// extracted by mini-css-extract-plugin
export var headerCell = "_4b-1";
export var loadingSpinnerContainer = "_4b-4";
export var rowWrapper = "_4b-3";
export var standaloneTable = "_4b-5";
export var table = "_4b-0";
export var white = "_4b-2";